/**
 * Opens Stripe Checkout (subscription). Requires deployed Edge Function `stripe-checkout`
 * and secrets STRIPE_SECRET_KEY, STRIPE_PRICE_ID (see supabase/functions README in repo).
 */
export async function createCheckoutSession(params: {
  accessToken: string;
  successUrl: string;
  cancelUrl: string;
}): Promise<{ url: string }> {
  const base = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
  if (!base || !anon) {
    throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY');
  }

  const res = await fetch(`${base.replace(/\/$/, '')}/functions/v1/stripe-checkout`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${params.accessToken}`,
      apikey: anon,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      success_url: params.successUrl,
      cancel_url: params.cancelUrl
    })
  });

  const json = (await res.json()) as { url?: string; error?: string };
  if (!res.ok) {
    throw new Error(json.error ?? `Checkout failed (${res.status})`);
  }
  if (!json.url) {
    throw new Error('Checkout did not return a URL');
  }
  return { url: json.url };
}
